<template>
  <div class="miembros-container">
    <!-- Header compacto y sutil -->
    <div class="compact-header">
      <div class="header-info">
        <v-icon color="#FFB800" class="mr-2">mdi-account-multiple</v-icon>
        <h1 class="compact-title">Gestión de Miembros</h1>
      </div>
    </div>
    
    <!-- Tabs con diseño mejorado -->
    <v-card class="mt-4" elevation="2">
      <v-tabs 
        v-model="tabActual" 
        background-color="grey lighten-5"
        color="primary"
        slider-color="primary"
        show-arrows
        class="tabs-container"
      >
        <v-tab key="lista" class="tab-item">
          <v-icon left size="20">mdi-account-group</v-icon>
          <span class="tab-text">Lista de Miembros</span>
        </v-tab>
        <v-tab key="vencidos" class="tab-item">
          <v-icon left size="20">mdi-calendar-alert</v-icon>
          <span class="tab-text">Miembros Vencidos</span>
        </v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-tabs-items v-model="tabActual" class="tabs-content">
        <!-- Tab 1: Lista de Miembros (funcionalidad original) -->
        <v-tab-item key="lista">
          <div class="tab-content-padding">
            <!-- Barra de herramientas mejorada -->
            <v-card flat class="mb-4">
              <v-card-text class="pb-0">
                <v-row align="center">
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="busqueda"
                      prepend-inner-icon="mdi-magnify"
                      label="Buscar miembros..."
                      single-line
                      hide-details
                      outlined
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="estadoFiltro"
                      :items="estadosPosibles"
                      item-text="text"
                      item-value="value"
                      label="Filtrar por estado"
                      clearable
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-filter-variant"
                    ></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="3">
                    <v-btn
                      color="#FFB800"
                      block
                      to="/nuevo-miembro"
                      elevation="1"
                      dark
                      class="simple-btn"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      Añadir Miembro
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
    <v-row>
      <v-col
        v-for="miembro in miembrosFiltrados"
        :key="miembro.matricula"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card class="mx-auto text-center" max-width="240" width="240" height="290" color="#f6f6f6">
          <v-avatar size="70" class="mt-1 mb-0" @click="verInformacion(miembro)" style="cursor: pointer;">
            <v-img
              :src="urlImagen(miembro.imagen)"
              contain
            ></v-img>
          </v-avatar>

          <v-card-title class="justify-center nombre-truncada">
            {{ miembro.nombre }}
          </v-card-title>

          <v-card-subtitle class="text-caption py-1">
            Código: {{ miembro.matricula }}
          </v-card-subtitle>
          
          <v-card-text class="justify-center membresia-truncada">
            Membresía: {{ miembro.membresia }}
            <v-icon v-if="miembro.pagado > miembro.precio && miembro.precio > 0" color="green" small class="ml-1" title="Pago mayor al valor de la membresía">mdi-checkbox-blank-circle</v-icon>
            <br v-if="miembro.estado === 'ACTIVO' || miembro.estado === 'PENDIENTE' || miembro.estado === 'VENCIDO'"/>
            <span v-if="miembro.estado === 'ACTIVO' || miembro.estado === 'PENDIENTE'">Días restantes: {{ miembro.diasRestantes }}</span>
            <div> 
              <v-chip
                :color="estado(miembro.estado)"
                text-color="white"
                small
              >
                {{ miembro.estado }}
                <span v-if="!miembro.estado">SIN MEMBRESÍA</span>
              </v-chip>
            </div>
          </v-card-text>

          <v-card-actions class="justify-center pt-1 pb-1">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  small
                  fab
                  v-bind="attrs"
                  v-on="on"
                  @click="editar(miembro.id)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="error"
                  small
                  fab
                  v-bind="attrs"
                  v-on="on"
                  @click="eliminar(miembro)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>

            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" small fab v-bind="attrs" v-on="on" @click="generarCredencial(miembro)">
                  <v-icon>mdi-card-account-details</v-icon>
                </v-btn>
              </template>
              <span>Generar credencial</span>
            </v-tooltip>

            <v-tooltip bottom color="success" v-if="!miembro.estado || miembro.estado === 'VENCIDO' || miembro.estado === 'PENDIENTE'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  small
                  fab
                  v-bind="attrs"
                  v-on="on"
                  @click="realizarPago(miembro.matricula)"
                >
                  <v-icon>mdi-wallet-membership</v-icon>
                </v-btn>
              </template>
              <span>Realizar pago</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12" class="text-center">
        <div class="text-subtitle-1 mb-2">
          Mostrando {{ miembrosFiltrados.length }} de {{ totalMiembros }} miembros
        </div>
        <v-pagination
          v-model="paginaActual"
          :length="totalPaginas"
          @input="cambiarPagina"
          :total-visible="7"
          circle
        ></v-pagination>
      </v-col>
    </v-row>
    <v-overlay :value="cargando">
      <v-progress-circular size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="mostrarRealizarPago" persistent max-width="600">
      <realizar-pago
        :matricula="matriculaSeleccionada"
        :membresia-actual="miembroSeleccionadoParaPago"
        :nombre-miembro="miembroSeleccionadoParaPago ? miembroSeleccionadoParaPago.nombre : ''"
        @cerrar="cerrarDialogoPago"
        @pagado="onPagado"
      />
    </v-dialog>

    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar
        :nombre="itemSeleccionado"
        @cancelar="cerrarDialogoEliminar"
        @eliminar="confirmarEliminar"
      />
    </v-dialog>

    <credencial-miembro :matricula="matriculaSeleccionada" :miembro="miembro"  @impreso="onImpreso" v-if="mostrarCredencial"/> 

    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
    >
      {{ mensaje.texto }}
    </v-snackbar>

    <v-dialog v-model="mostrarInformacionMiembro" max-width="700px">
      <v-card>
        <v-card-title class="headline amber lighten-2">
          Información del Miembro
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarDialogoInformacion">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="miembroSeleccionado">
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-avatar size="100" class="mb-4">
                  <v-img
                    :src="urlImagen(miembroSeleccionado.imagen)"
                    contain
                  ></v-img>
                </v-avatar>
              </v-col>
              <v-col cols="12" md="6">
                <strong>Nombre:</strong> {{ miembroSeleccionado.nombre }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Matrícula:</strong> {{ miembroSeleccionado.matricula }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Estado:</strong> 
                <v-chip
                  :color="estado(miembroSeleccionado.estado)"
                  text-color="white"
                  small
                >
                  {{ miembroSeleccionado.estado }}
                  <span v-if="!miembroSeleccionado.estado">SIN MEMBRESÍA</span>
                </v-chip>
              </v-col>
              <v-col cols="12" md="6">
                <strong>Membresía:</strong> {{ miembroSeleccionado.membresia }}
                <div v-if="miembroSeleccionado.estado === 'ACTIVO' || miembroSeleccionado.estado === 'PENDIENTE' || miembroSeleccionado.estado === 'VENCIDO'">
                  Días restantes: {{ miembroSeleccionado.diasRestantes }}
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <strong>Teléfono:</strong> {{ miembroSeleccionado.telefono }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Dirección:</strong> {{ miembroSeleccionado.direccion }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Objetivo:</strong> {{ miembroSeleccionado.objetivo }}
              </v-col>
              <v-col cols="12" md="6" v-if="miembroSeleccionado.fechaInicio">
                <strong>Fecha de inicio de membresía:</strong> {{ miembroSeleccionado.fechaInicio }}
              </v-col>
              <v-col cols="12" md="6" v-if="miembroSeleccionado.fechaFin">
                <strong>Fecha de fin de membresía:</strong> {{ miembroSeleccionado.fechaFin }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Valor pagado:</strong> ${{ miembroSeleccionado.pagado }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <!-- Botones para pagos anticipados -->
          <v-btn 
            v-if="miembroSeleccionado && miembroSeleccionado.estado === 'ACTIVO'"
            color="orange" 
            text 
            @click="abrirPagoAnticipado"
          >
            <v-icon left>mdi-clock-plus</v-icon>
            Pago Anticipado
          </v-btn>
          
          <v-btn 
            v-if="miembroSeleccionado"
            color="blue" 
            text 
            @click="verPagosAnticipados"
          >
            <v-icon left>mdi-eye</v-icon>
            Ver Pagos Anticipados
          </v-btn>
          
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cerrarDialogoInformacion">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Pago Anticipado -->
    <v-dialog v-model="mostrarDialogoPagoAnticipado" persistent max-width="600">
      <realizar-pago
        v-if="miembroSeleccionado"
        :matricula="miembroSeleccionado.matricula"
        :membresia-actual="miembroSeleccionado"
        :nombre-miembro="miembroSeleccionado.nombre"
        :es-pago-anticipado="true"
        @cerrar="cerrarDialogoPagoAnticipado"
        @pagado="onPagoAnticipadoRealizado"
      />
    </v-dialog>

    <!-- Diálogo para Ver Pagos Anticipados -->
    <v-dialog v-model="mostrarDialogoPagosAnticipados" max-width="1000">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-clock-check-outline</v-icon>
          Historial de Pagos Anticipados
          <v-spacer></v-spacer>
          <v-chip color="white" text-color="primary" small>
            {{ miembroSeleccionado ? miembroSeleccionado.nombre : '' }}
          </v-chip>
          <v-btn icon color="white" @click="cerrarDialogoPagosAnticipados" class="ml-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-0">
          <!-- Loading -->
          <div v-if="cargandoPagosAnticipados" class="text-center pa-8">
            <v-progress-circular indeterminate color="primary" size="60"></v-progress-circular>
            <div class="mt-4 subtitle-1">Cargando pagos anticipados...</div>
          </div>

          <!-- Lista de pagos anticipados -->
          <div v-else-if="pagosAnticipados.length > 0">
            <!-- Resumen simplificado -->
            <v-container class="py-4">
              <v-row>
                <v-col cols="12" md="4">
                  <div class="text-center">
                    <div class="display-1 font-weight-bold primary--text">{{ pagosAnticipados.length }}</div>
                    <div class="subtitle-2 text--secondary">Total Pagos</div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-center">
                    <div class="display-1 font-weight-bold success--text">{{ pagosActivados }}</div>
                    <div class="subtitle-2 text--secondary">Activados</div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="text-center">
                    <div class="display-1 font-weight-bold orange--text">{{ pagosPendientes }}</div>
                    <div class="subtitle-2 text--secondary">Pendientes</div>
                  </div>
                </v-col>
              </v-row>
            </v-container>

            <v-divider></v-divider>

            <!-- Tabla detallada -->
            <v-data-table
              :headers="headersPagosAnticipados"
              :items="pagosAnticipados"
              class="elevation-0"
              no-data-text="No hay pagos anticipados"
              :items-per-page="10"
            >
              <template v-slot:item.monto_pagado="{ item }">
                <span class="font-weight-bold">${{ Number(item.monto_pagado).toLocaleString() }}</span>
              </template>
              
              <template v-slot:item.nombreMembresia="{ item }">
                <span :class="item.nombreMembresia === 'Membresía eliminada' ? 'grey--text' : ''">
                  {{ item.nombreMembresia || 'Membresía eliminada' }}
                </span>
              </template>
              
              <template v-slot:item.fecha_pago="{ item }">
                {{ formatearFecha(item.fecha_pago) }}
              </template>
              
              <template v-slot:item.estado="{ item }">
                <v-chip
                  :color="item.activa == 1 ? 'success' : 'orange'"
                  :text-color="item.activa == 1 ? 'white' : 'white'"
                  small
                >
                  {{ item.activa == 1 ? 'ACTIVADO' : 'PENDIENTE' }}
                </v-chip>
              </template>
              
              <template v-slot:item.fecha_activacion="{ item }">
                <span v-if="item.fecha_activacion">
                  {{ formatearFecha(item.fecha_activacion) }}
                </span>
                <span v-else class="grey--text caption">
                  Esperando activación
                </span>
              </template>

              <template v-slot:item.metodo_pago="{ item }">
                <v-chip small :color="getColorMetodoPago(item.metodo_pago)" text-color="white">
                  {{ item.metodo_pago }}
                </v-chip>
              </template>

              <template v-slot:item.acciones="{ item }">
                <div class="d-flex gap-1">
                  <v-btn
                    v-if="item.activa == 0"
                    x-small
                    color="success"
                    @click="activarPagoAnticipado(item)"
                    :loading="procesandoAccion === item.id"
                  >
                    <v-icon small>mdi-check</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.activa == 0"
                    x-small
                    color="error"
                    @click="cancelarPagoAnticipado(item)"
                    :loading="procesandoAccion === item.id"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                  <span v-else class="caption grey--text">
                    Ya activado
                  </span>
                </div>
              </template>
            </v-data-table>
          </div>

          <!-- Sin pagos anticipados -->
          <div v-else class="text-center pa-12">
            <v-icon size="64" color="grey lighten-1">mdi-clock-outline</v-icon>
            <div class="mt-4 headline grey--text text--lighten-1">No hay pagos anticipados</div>
            <div class="mt-2 body-2 grey--text">
              Este miembro no tiene pagos anticipados registrados
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrarDialogoPagosAnticipados">
            <v-icon left>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          </div>
        </v-tab-item>

        <!-- Tab 2: Miembros Vencidos (Carga Diferida) -->
        <v-tab-item key="vencidos">
          <div class="tab-content-padding">
            <!-- Carga diferida del componente de miembros vencidos -->
            <div v-if="!miembrosVencidosComponenteLoaded && tabActual === 1" class="text-center py-8">
              <v-progress-circular indeterminate color="warning" size="40"></v-progress-circular>
              <div class="mt-3 text--secondary">Cargando módulo de miembros vencidos...</div>
            </div>
            <MiembrosVencidos 
              v-else-if="miembrosVencidosComponenteLoaded" 
              @loaded="onMiembrosVencidosLoaded"
            />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import MiembrosVencidos from "./MiembrosVencidos.vue";
import Utiles from "../../Servicios/Utiles";
import RealizarPago from "./RealizarPago.vue";
import DialogoEliminar from "../Dialogos/DialogoEliminar.vue";
import CredencialMiembro from "./CredencialMiembro.vue";

export default {
  name: "Miembros",
  components: { RealizarPago, DialogoEliminar, CredencialMiembro, MiembrosVencidos },

  data: () => ({
    tabActual: 0, // 0 = Lista de Miembros, 1 = Miembros Vencidos
    miembrosVencidosComponenteLoaded: false, // Para carga diferida
    busquedaTimeout: null, // Para debounce en búsqueda
    miembrosCache: null, // Cache simple para optimizar
    cargando: false,
    miembros: [],
    estadoFiltro: null,
    estadosPosibles: [
      { text: "ACTIVO", value: "ACTIVO" },
      { text: "VENCIDO", value: "VENCIDO" },
      { text: "PENDIENTE", value: "PENDIENTE" },
      { text: "POR VENCER", value: "POR_VENCER" },
      { text: "SIN MEMBRESÍA", value: "SIN MEMBRESÍA" },
      
    ],
    busqueda: '',
    mostrarRealizarPago: false,
    mostrarDialogoEliminar: false,
    mostrarCredencial: false,
    matriculaSeleccionada: '',
    itemSeleccionado: '',
    miembro: null,
    mostrarInformacionMiembro: false,
    miembroSeleccionado: null,
    mostrarMensaje: false,
    mensaje: {
      color: '',
      texto: ''
    },
    paginaActual: 1,
    totalMiembros: 0,
    totalPaginas: 1,
    miembroSeleccionadoParaPago: null,
    // Variables para pagos anticipados
    mostrarDialogoPagoAnticipado: false,
    mostrarDialogoPagosAnticipados: false,
    pagosAnticipados: [],
    cargandoPagosAnticipados: false,
    procesandoAccion: null
  }),

  computed: {
    miembrosFiltrados() {
      return this.miembros;
    },
    
    // Propiedades computadas para pagos anticipados
    pagosActivados() {
      return this.pagosAnticipados.filter(pago => pago.activa == 1).length;
    },
    
    pagosPendientes() {
      return this.pagosAnticipados.filter(pago => pago.activa == 0).length;
    },
    
    headersPagosAnticipados() {
      return [
        { text: 'ID', value: 'id', width: '80px' },
        { text: 'Membresía', value: 'nombreMembresia', width: '200px' },
        { text: 'Monto', value: 'monto_pagado', width: '120px' },
        { text: 'Método', value: 'metodo_pago', width: '120px' },
        { text: 'Fecha Pago', value: 'fecha_pago', width: '140px' },
        { text: 'Estado', value: 'estado', width: '120px' },
        { text: 'Fecha Activación', value: 'fecha_activacion', width: '140px' },
        { text: 'Acciones', value: 'acciones', width: '150px', sortable: false }
      ];
    }
  },

  watch: {
    // Carga diferida cuando se cambia al tab de miembros vencidos
    tabActual(newVal) {
      if (newVal === 1 && !this.miembrosVencidosComponenteLoaded) {
        // Simular carga del módulo con un pequeño delay para UX
        setTimeout(() => {
          this.miembrosVencidosComponenteLoaded = true;
        }, 300);
      }
    },
    
    busqueda() {
      // Debounce para optimizar búsquedas
      clearTimeout(this.busquedaTimeout);
      this.busquedaTimeout = setTimeout(() => {
        this.paginaActual = 1;
        this.obtenerMiembros();
      }, 300); // 300ms de retraso
    },
    estadoFiltro() {
      this.paginaActual = 1;
      this.obtenerMiembros();
    }
  },

  mounted() {
    this.obtenerMiembros();
  },

  beforeDestroy() {
    // Limpiar timeouts para evitar memory leaks
    if (this.busquedaTimeout) {
      clearTimeout(this.busquedaTimeout);
    }
  },

  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    // Método para limpiar cache cuando se actualicen datos
    limpiarCache() {
      this.miembrosCache = null;
    },

    // Método para manejar cuando el componente de miembros vencidos termine de cargar
    onMiembrosVencidosLoaded() {
      console.log('Componente de miembros vencidos cargado completamente');
    },

    obtenerMiembros() {
      // Cache simple para evitar llamadas repetidas
      const cacheKey = `${this.paginaActual}-${this.busqueda}-${this.estadoFiltro}`;
      if (this.miembrosCache && this.miembrosCache.key === cacheKey) {
        return; // Usar datos del cache
      }

      this.cargando = true;
      const payload = {
        metodo: "get",
        pagina: this.paginaActual,
        busqueda: this.busqueda,
        estado: this.estadoFiltro === null ? 'Todos' : this.estadoFiltro
      };
      HttpService.obtenerConDatos(payload, "miembros.php").then((resultado) => {
        this.miembros = resultado.miembros;
        this.totalMiembros = resultado.total;
        this.totalPaginas = resultado.paginas;
        
        // Guardar en cache
        this.miembrosCache = {
          key: cacheKey,
          data: resultado,
          timestamp: Date.now()
        };
        
        this.cargando = false;
      }).catch((error) => {
        console.error('Error al obtener miembros:', error);
        this.cargando = false;
      });
    },

    estado(val) {
      return val === "ACTIVO"
        ? "success"
        : val === "VENCIDO"
        ? "error"
        : val === "PENDIENTE"
        ? "orange darken-2"
        : "warning";
    },

    generarCredencial(miembro){
      this.matriculaSeleccionada = miembro.matricula
      this.miembro = miembro
      this.mostrarCredencial = true
    },

    onImpreso(resultado) {
      this.mostrarCredencial = resultado;
    },

    eliminar(miembro) {
      this.itemSeleccionado = miembro.nombre;
      this.miembro = miembro;
      this.mostrarDialogoEliminar = true;
    },

    cerrarDialogoEliminar() {
      this.mostrarDialogoEliminar = false;
      this.miembro = null;
    },

    confirmarEliminar() {
      this.cargando = true;
      let payload = {
        metodo: "eliminar",
        id: this.miembro.id,
      };
      HttpService.eliminar("miembros.php", payload).then((eliminado) => {
        if (eliminado) {
          this.mostrarDialogoEliminar = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Miembro eliminado";
          this.mensaje.color = "success";
          this.cargando = false;
          this.obtenerMiembros();
        }
      });
    },

    editar(idMiembro) {
      this.$router.push({
        name: "EditarMiembro",
        params: { id: idMiembro },
      });
    },

    realizarPago(matricula) {
      const miembro = this.miembros.find(m => m.matricula === matricula);
      this.matriculaSeleccionada = matricula;
      this.miembroSeleccionadoParaPago = miembro ? {
        idMembresia: miembro.idMembresia,
        nombre: miembro.nombre,
        precio: miembro.precio,
        duracion: miembro.duracion,
        membresia: miembro.membresia,
        estado: miembro.estado,
        diasRestantes: miembro.diasRestantes,
        fechaFin: miembro.fechaFin,
        fechaInicio: miembro.fechaInicio
      } : null;
      this.mostrarRealizarPago = true;
    },

    cerrarDialogoPago() {
      this.mostrarRealizarPago = false;
      this.matriculaSeleccionada = "";
    },

    onPagado(resultado) {
      if (resultado) {
        this.limpiarCache(); // Limpiar cache cuando se realice un pago
        this.mostrarRealizarPago = false;
        this.mostrarMensaje = true;
        this.mensaje = {
          color: "success",
          texto: "Pago realizado con éxito",
        };
        this.obtenerMiembros();
        if (this.miembroSeleccionado && this.miembroSeleccionado.matricula) {
          const payload = { metodo: 'get', busqueda: this.miembroSeleccionado.matricula };
          HttpService.obtenerConDatos(payload, 'miembros.php').then((res) => {
            if (res && res.miembros && res.miembros.length > 0) {
              this.miembroSeleccionado = res.miembros[0];
            }
          });
        }
      }
    },

    verInformacion(miembro) {
      this.miembroSeleccionado = miembro;
      this.mostrarInformacionMiembro = true;
    },

    cerrarDialogoInformacion() {
      this.mostrarInformacionMiembro = false;
      this.miembroSeleccionado = null;
    },

    cambiarPagina(pagina) {
      this.paginaActual = pagina;
      this.obtenerMiembros();
    },

    // Métodos para pagos anticipados
    abrirPagoAnticipado() {
      this.mostrarDialogoPagoAnticipado = true;
    },

    cerrarDialogoPagoAnticipado() {
      this.mostrarDialogoPagoAnticipado = false;
    },

    verPagosAnticipados() {
      this.mostrarDialogoPagosAnticipados = true;
      this.cargarPagosAnticipados();
    },

    cerrarDialogoPagosAnticipados() {
      this.mostrarDialogoPagosAnticipados = false;
      this.pagosAnticipados = [];
    },

    // Métodos auxiliares para la visualización de pagos anticipados
    getColorMetodoPago(metodo) {
      const colores = {
        'Efectivo': 'green',
        'Tarjeta': 'blue',
        'Transferencia': 'purple',
        'Nequi': 'orange',
        'Daviplata': 'red'
      };
      return colores[metodo] || 'grey';
    },

    getIconoMetodoPago(metodo) {
      const iconos = {
        'Efectivo': 'mdi-cash',
        'Tarjeta': 'mdi-credit-card',
        'Transferencia': 'mdi-bank-transfer',
        'Nequi': 'mdi-cellphone',
        'Daviplata': 'mdi-cellphone'
      };
      return iconos[metodo] || 'mdi-currency-usd';
    },

    onPagoAnticipadoRealizado(resultado) {
      if (resultado) {
        this.mostrarDialogoPagoAnticipado = false;
        this.mostrarMensaje = true;
        this.mensaje = {
          color: 'success',
          texto: 'Pago anticipado registrado con éxito'
        };
        this.obtenerMiembros(); // Actualizar la lista
        
        // Si el diálogo de pagos anticipados está abierto, refrescar los datos
        if (this.mostrarDialogoPagosAnticipados) {
          this.cargarPagosAnticipados();
        }
      }
    },

    // Método auxiliar para cargar pagos anticipados sin abrir el diálogo
    cargarPagosAnticipados() {
      if (!this.miembroSeleccionado) return;
      
      this.cargandoPagosAnticipados = true;
      
      const payload = {
        metodo: 'obtener_pagos_anticipados',
        matricula: this.miembroSeleccionado.matricula
      };
      
      HttpService.obtenerConDatos(payload, 'miembros.php')
        .then(respuesta => {
          this.pagosAnticipados = respuesta || [];
          this.cargandoPagosAnticipados = false;
        })
        .catch(error => {
          console.error('Error al cargar pagos anticipados:', error);
          this.pagosAnticipados = [];
          this.cargandoPagosAnticipados = false;
        });
    },

    formatearFecha(fecha) {
      if (!fecha) return '';
      return new Date(fecha).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    activarPagoAnticipado(pago) {
      if (!confirm(`¿Está seguro de activar el pago anticipado de $${Number(pago.monto_pagado).toLocaleString()}?\n\nEsto activará inmediatamente la membresía del miembro.`)) {
        return;
      }

      this.procesandoAccion = pago.id;
      
      const payload = {
        metodo: 'activar_pago_anticipado',
        id: pago.id,
        idUsuario: localStorage.getItem('idUsuario')
      };

      HttpService.obtenerConDatos(payload, 'miembros.php')
        .then(respuesta => {
          if (respuesta.exito) {
            this.$toast.success('Pago anticipado activado exitosamente');
            this.cargarPagosAnticipados();
            this.obtenerMiembros(); // Actualizar la lista de miembros
          } else {
            this.$toast.error(respuesta.mensaje || 'Error al activar el pago anticipado');
          }
        })
        .catch(error => {
          console.error('Error al activar pago anticipado:', error);
          this.$toast.error('Error al activar el pago anticipado');
        })
        .finally(() => {
          this.procesandoAccion = null;
        });
    },

    cancelarPagoAnticipado(pago) {
      const motivo = prompt(`¿Por qué desea cancelar este pago anticipado?\n\nMembresía: ${pago.nombreMembresia}\nMonto: $${Number(pago.monto_pagado).toLocaleString()}`);
      
      if (motivo === null) return; // Usuario canceló
      if (motivo.trim() === '') {
        this.$toast.error('Debe proporcionar un motivo para cancelar el pago');
        return;
      }

      this.procesandoAccion = pago.id;
      
      const payload = {
        metodo: 'cancelar_pago_anticipado',
        id: pago.id,
        idUsuario: localStorage.getItem('idUsuario'),
        motivo: motivo.trim()
      };

      HttpService.obtenerConDatos(payload, 'miembros.php')
        .then(respuesta => {
          if (respuesta.exito) {
            this.$toast.success('Pago anticipado cancelado exitosamente');
            this.cargarPagosAnticipados();
          } else {
            this.$toast.error(respuesta.mensaje || 'Error al cancelar el pago anticipado');
          }
        })
        .catch(error => {
          console.error('Error al cancelar pago anticipado:', error);
          this.$toast.error('Error al cancelar el pago anticipado');
        })
        .finally(() => {
          this.procesandoAccion = null;
        });
    }
  },

  created() {
    this.obtenerMiembros();
  },
};
</script>

<style scoped>
/* Estilos generales mejorados */
.miembros-container {
  background-color: #f8f9fa;
  min-height: 100vh;
  padding: 20px;
}

/* Header compacto */
.compact-header {
  background: white;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  border-left: 4px solid #FFB800;
}

.header-info {
  display: flex;
  align-items: center;
}

.compact-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

/* Botón simple */
.simple-btn {
  font-weight: 500 !important;
  text-transform: none !important;
}

/* Tabs */
.tabs-container {
  background: white !important;
}

.tab-item {
  text-transform: none !important;
  font-weight: 500;
  min-width: 200px;
}

.tab-text {
  margin-left: 4px;
  font-size: 0.9rem;
}

.tabs-content {
  background-color: #f8f9fa;
}

.tab-content-padding {
  padding: 24px;
}

/* Cards y elementos generales */
p {
  margin: 0;
}

.nombre-truncada {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin: 0 auto;
  display: block;
}

.membresia-truncada {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  margin: 0 auto;
  display: block;
}

/* Responsive */
@media (max-width: 768px) {
  .miembros-container {
    padding: 12px;
  }
  
  .page-header {
    padding: 16px;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .tab-content-padding {
    padding: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Miembros/Miembros.vue